"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.superAdministratorPermissions = void 0;
var enum_1 = require("../enum");
exports.superAdministratorPermissions = [
    enum_1.Permissions.CanIgnoreCustomGrants,
];
